import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appAddress]'
})
export class AddressDirective {

  @Output() validatorAddress = new EventEmitter<boolean>();
  // regex: validates alphanumeric strings and characters , . - Á á É é Í í Ó ó Ú ú Ñ ñ à
  private regex: RegExp = new RegExp(/^[a-zA-Z0-9\,\.\-\s\u00c1\u00e1\u00c9\u00e9\u00cd\u00ed\u00f3\u00d3\u00da\u00fa\u00E0\u00FC\u00f1\u00d1çÇ\'àÀèÈìÌòÒùÙ]*$/);

  constructor() { }

  @HostListener('keypress', ['$event'])
  onKeyPress(event) {
    if (event.key) {
      const val = this.replaceString(event.srcElement.value);
      event.srcElement.value = val;
      const inp = event.key;
      if (this.regex.test(inp)) {
        return true;
      } else {
        event.preventDefault();
        return false;
      }
    } else {
      return true;
    }
  }

  @HostListener('blur', ['$event'])
  onBlur(event) {
    const val = this.replaceString(event.srcElement.value);
    event.srcElement.value = val;
    if (event.srcElement.value) {
      const inp = event.srcElement.value;
      if (this.regex.test(inp)) {
        this.validatorAddress.emit(true);
        return true;
      } else {
        this.validatorAddress.emit(false);
        return false;
      }
    } else {
      this.validatorAddress.emit(true);
      return true;
    }
  }

  /**
   * Function to replace the repeated characters
   * @param value The string to replace
   * @returns The string with characters replaced
   */
  replaceString(value: string): string {
    return value
      .replace(/\-{2,}/g, '-')
      .replace(/\.{2,}/g, '.')
      .replace(/\,{2,}/g, ',');
  }
}
